import { useState } from "react";
import useSignoutButton from './useSignOutButton';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { PAGE_SECTION_ID } from '../../EmbeddedReport/utils/embeddingConfig';

export enum MENU_ITEM {
  MY_SETTINGS,
  APP_SETTINGS,
  USER_MANAGEMENT
}

/**
 * Custom hook for Nav Bar implementation logic
 */
export const useNavBar = () => {
  const { handleLogout } = useSignoutButton();
  const [activeMenu, setActiveMenu] = useState<MENU_ITEM | null>(null);
  const [mobileMenuShow, setMobileMenuShow] = useState(false);
  const isMobile = useIsMobile();
  const handleMobileMenuShow = () => setMobileMenuShow(!mobileMenuShow);
  /**
   * fix for a bug where report iFrame prevents
   * user management grid drag feature
   */
  const togglePointerEvents = (apply: boolean) => {
    const pageSection = document.getElementById(PAGE_SECTION_ID)
    if (pageSection) {
      if (apply) {
        pageSection.style.setProperty('pointer-events', 'none')
      } else {
        pageSection.style.removeProperty('pointer-events')
      }
    }
  }
  const toggleMenuItem = (value: MENU_ITEM) => {
    if (activeMenu === value) {
      togglePointerEvents(false)
      setActiveMenu(null);
      return;
    }
    if (value === MENU_ITEM.USER_MANAGEMENT) {
      togglePointerEvents(true)
    }
    setActiveMenu(value);
  }
  return {
    isMobile,
    activeMenu,
    mobileMenuShow,
    handleLogout,
    toggleMenuItem,
    handleMobileMenuShow,
  };
};
